import { supabase } from '../../config/supabase';
import { MonthlyStats } from '../../types/property';
import { updatePropertyStats } from './propertyStats';
import { calculateMonthlyStats } from './statsCalculator';

export const getMonthlyStats = async (propertyId: string): Promise<MonthlyStats[]> => {
  const { data, error } = await supabase
    .from('monthly_stats')
    .select('*')
    .eq('property_id', propertyId)
    .order('year', { ascending: false })
    .order('month', { ascending: false });

  if (error) throw error;
  return data.map(calculateMonthlyStats);
};

export const createMonthlyStats = async (stats: Omit<MonthlyStats, 'id' | 'created_at'>): Promise<MonthlyStats> => {
  const { data, error } = await supabase
    .from('monthly_stats')
    .insert([{
      property_id: stats.propertyId,
      year: stats.year,
      month: stats.month,
      revenue: stats.revenue,
      cleaning_costs: stats.cleaningCosts,
      inmohost_costs: stats.inmohostCosts,
      profit: stats.profit,
      occupancy_rate: stats.occupancyRate,
      reservations: stats.reservations,
      average_night_price: stats.averageNightPrice,
      average_stay_duration: stats.averageStayDuration
    }])
    .select()
    .single();

  if (error) throw error;

  await updatePropertyStats(stats.propertyId);
  return calculateMonthlyStats(data);
};